<p-drawer
    appendTo="body"
    [(visible)]="visible"
    position="right"
    [style]="{ 'max-width': '90%', width: width }"
    styleClass="max-w-[90%] w-[800px]"
>
    <ng-template pTemplate="header">
        <h1
            class="section-header mt-2 px-2 pt-2 pb-4 mb-2 text-lg flex items-center absolute top-0 left-0 w-full"
        >
            <mat-icon class="text-primary">help</mat-icon>
            <span class="pl-2 text-slate-500"> Servicio de ayuda </span>
        </h1>
    </ng-template>
    <div class="h-full w-full relative">
        <div class="p-2 absolute top-0 left-0 h-full w-full text-black">
            <div class="border rounded-md relative h-full w-full">
                <div
                    [ngClass]="{ hidden: !error }"
                    class="p-2 h-full w-full flex items-center justify-center"
                >
                    <span class="text-center">
                        <svg
                            class="w-40 h-40 my-0 mx-auto dark:text-slate-200 text-primary"
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="File_Off">
                                <g>
                                    <path
                                        d="M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"
                                    ></path>
                                    <path
                                        d="M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"
                                    ></path>
                                </g>
                            </g>
                        </svg>
                        <p class="font-semibold mt-6">
                            Lo sentimos, no ha sido posible configurar el
                            servicio de ayuda.
                            <br />
                            Por favor intentelo nuevamente.
                        </p>
                        <p class="font-semibold mt-6 text-slate-500">
                            Si el error persiste, por favor repórtelo al área de
                            TI para su atención.
                        </p>
                    </span>
                </div>
                <div
                    [ngClass]="{ hidden: initialized || error }"
                    class="p-2 h-full w-full flex items-center justify-center"
                >
                    <span class="text-center">
                        <div class="flex items-center justify-center">
                            <div class="relative text-center">
                                <div
                                    class="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"
                                ></div>
                                <div
                                    class="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-primary animate-spin"
                                ></div>
                            </div>
                        </div>
                        <p class="font-semibold mt-6">
                            Estamos configurando el subsistema de ayuda
                            <br />
                            por favor espere...
                        </p>
                    </span>
                </div>
                <div
                    *ngIf="initialized"
                    class="absolute top-0 left-0 pt-12 p-2 pl-4 h-full w-full"
                >
                    <div
                        [ngClass]="{ hidden: resourceNotFound || !initialized }"
                        #divResource
                        class="max-h-full overflow-y-auto"
                    ></div>
                    <div
                        [ngClass]="{
                            hidden: !resourceNotFound || !initialized
                        }"
                        class="h-full w-full items-center flex justify-center flex-col gap-10"
                    >
                        <div class="px-4 md:px-10 w-full relative pb-12">
                            <div class="relative">
                                <div class="absolute">
                                    <div>
                                        <h1
                                            class="my-2 mb-5 text-gray-800 font-bold text-3xl text-center"
                                        >
                                            Lo sentimos, este recurso no está
                                            disponible.
                                        </h1>
                                        <p
                                            class="my-2 text-gray-800 font-semibold"
                                        >
                                            Es posible que el enlace esté roto o
                                            que se haya eliminado la página. Si
                                            usted cree que no debería de
                                            visualizar este mensaje de error
                                            notifíquelo al área de TI para
                                            brindale una solución.
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    <img src="/assets/images/pages/404.png" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <img src="/assets/images/pages/unplug.png" />
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="initialized"
                    class="absolute top-0 left-0 w-full p-2"
                >
                    <p *ngIf="title" class="font-bold text-slate-500">
                        {{ title }}
                    </p>
                    <hr *ngIf="title" class="separator mb-2" />
                </div>
            </div>
        </div>
    </div>
</p-drawer>
